import 'preact/debug';

// import '@fontsource/montserrat/400.css';
// import '@fontsource/montserrat/500.css';
// import '@fontsource/montserrat/600.css';
// import '@fontsource/montserrat/700.css';
// import '@fontsource/montserrat/800.css';
import './style/index.css';

import App from './components/app';

// Глобальное состояние для сертификата
export const certState = {
  isCertFound: {
    mc: false,
    harica: false
  },
  isChecked: false,
};

// Функция для проверки сертификата (вызывается один раз при загрузке)
export const checkCertGlobally = (): Promise<{ mc: boolean; harica: boolean }> => {
  if (typeof window === 'undefined') return Promise.resolve({mc: false, harica: false});
  
  // Проверяем URL-параметры для имитации (только в dev)
  const urlParams = new URLSearchParams(window.location.search);
  if (urlParams.has('mockCert')) {
    const mockValue = urlParams.get('mockCert');
    switch (mockValue) {
      case 'both':
        return Promise.resolve({ mc: true, harica: true });
      case 'mc-only':
        return Promise.resolve({ mc: true, harica: false });
      case 'harica-only':
        return Promise.resolve({ mc: false, harica: true });
      case 'none':
        return Promise.resolve({ mc: false, harica: false });
    }
  }
  
  // Если уже проверяли — возвращаем сохранённое значение
  if (certState.isChecked && certState.isCertFound) {
    return Promise.resolve(certState.isCertFound);
  }

  // Выполняем оба запроса параллельно
  const mcPromise = fetch('https://mc.sovcombank.ru')
    .then(() => true)
    .catch(() => false);

  const haricaPromise = fetch('https://hrc.sovcombank.ru')
    .then(() => true)
    .catch(() => false);

  return Promise.all([mcPromise, haricaPromise]).then(([mc, harica]) => {
    const result = { mc, harica };
    
    certState.isCertFound = result;
    certState.isChecked = true;
    
    return result;
  });
};

export default App;
